import React from "react";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import SupervisorApi from "../../utility/supervisorApi";
import { useQuery } from "@tanstack/react-query";
import ImageWithPlaceholder from "../../components/ImageWithPlaceholder";
import { formatNumbersWithDecimal } from "../../components/formatNumbersWIthDecimal";
import { formatNumbers } from "../../components/formatNumbers";
function DashboardOverview({ currencyDetails }) {
  const { fetchOnlyData } = SupervisorApi();

  const { data, isLoading } = useQuery({
    queryKey: ["stats"],
    queryFn: () => fetchOnlyData("dashboard/stats"),
    retry: 1,
    keepPreviousData: true,
    staleTime: 30 * 60 * 1000,
    cacheTime: 60 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  // console.log("checkhere", data);

  return (
    <div className=" grid grid-col-2 lg:grid-cols-4  gap-1 lg:gap-4 mb-6 ">
      <div className="flex items-center gap-4 border border-black rounded-md p-2">
        <div className="p-2 bg-[#34A85326] rounded-md">
          <LocalAtmIcon sx={{ fontSize: "24px" }} />
        </div>
        <div className=" rounded-md">
          <p>Total Revenue</p>
          <h3 className="font-semibold text-lg">
            {currencyDetails}
            {formatNumbersWithDecimal(data?.totalRevenue)}
          </h3>
        </div>
        {/* <TrendingUpIcon sx={{ fontSize: "30px" }} /> */}
      </div>

      <div className="flex items-center gap-4 border border-black rounded-md p-2">
        <div className="p-2 bg-customBlue rounded-md">
          <ViewInArIcon sx={{ fontSize: "20px", color: "#002FFF" }} />
        </div>
        <div className=" rounded-md">
          <p>Total Stock</p>
          <h3 className="font-semibold text-lg">
            {formatNumbers(data?.totalStock)}
          </h3>
        </div>
        {/* <TrendingUpIcon sx={{ fontSize: "30px" }} /> */}
      </div>

      <div className="flex items-center gap-4 border border-black rounded-md p-2">
        <div className="p-2 bg-iconRed rounded-md">
          <ViewInArIcon sx={{ fontSize: "20px", color: "#FF0000" }} />
        </div>
        <div className="  rounded-md">
          <p>Out of Stock</p>
          <h3 className="font-semibold text-lg">{data?.outOfStock} Items</h3>
        </div>
        {/* <TrendingUpIcon sx={{ fontSize: "30px" }} /> */}
      </div>

      <div className="flex items-center gap-4 border border-black rounded-md p-2">
        <ImageWithPlaceholder
          item={data?.topProduct}
          className="w-8 rounded-sm"
          placeholderClassName="text-[20px] bg-gray-200 p-2 font-semi-bold rounded-md"
        />
        <div className=" rounded-md">
          <p>Top Product</p>
          <h3 className="font-semibold text-lg">
            {data?.topProduct?.product_name}
          </h3>
        </div>
      </div>
    </div>
  );
}

export default DashboardOverview;
